import React from 'react';
import Lottie from 'lottie-react';
import Not_Found from '../../../constants/not-found.json';
import { Link } from 'react-router-dom';
import { selectAccountDetails } from 'selectors/account-selector';
import { useAppSelector } from 'store/hooks';

export default function NotFound() {
  const { user } = useAppSelector(selectAccountDetails);

  return (
    <div className="flex h-screen flex-col items-center justify-center">
      <Lottie animationData={Not_Found} style={{ height: 400 }} />
      <Link to={user ? '/dashboard' : '/'}>
        <button
          type="button"
          className="rounded-lg bg-primary-900 p-3 text-center text-xs font-medium text-white"
        >
          {user ? 'Go back to dashboard' : 'Go back to homepage'}
        </button>
      </Link>
    </div>
  );
}
